import React, { FC } from 'react'
import IconSVG, { IconSVGProps } from '../IconSVG'

export const IconVersions: FC<IconSVGProps> = ({ ...props }) => (
  <IconSVG className="IconVersions" {...props}>
    <svg height="100%" width="18" viewBox="0 0 18 16" fill="currentColor">
      <path d="M8.4375 0.125C7.81618 0.125 7.3125 0.628681 7.3125 1.25V14.75C7.3125 15.3713 7.81618 15.875 8.4375 15.875H16.875C17.4963 15.875 18 15.3713 18 14.75V1.25C18 0.62868 17.4963 0.125 16.875 0.125H8.4375ZM8.4375 1.25L16.875 1.25V14.75H8.4375V1.25Z" />
      <path d="M4.5 1.25C3.87868 1.25 3.375 1.75368 3.375 2.375V13.625C3.375 14.2463 3.87868 14.75 4.5 14.75H6.1875V13.625H4.5V2.375H6.1875V1.25H4.5Z" />
      <path d="M1.125 2.375C0.50368 2.375 0 2.87868 0 3.5V12.5C0 13.1213 0.503679 13.625 1.125 13.625H2.25V12.5H1.125V3.5H2.25V2.375H1.125Z" />
    </svg>
  </IconSVG>
)
